import "utfront";
import "./style.css";

const sections = document.querySelectorAll<HTMLDivElement>(
    "div.collapsible-section",
);
for (const section of sections) {
    (() => {
        const title = section.querySelector<HTMLDivElement>("div.title");
        const icon = title?.querySelector<HTMLElement>("svg");
        const content =
            section.querySelector<HTMLDivElement>("div.text-bodytext");

        if (!title || !icon || !content) {
            return;
        }

        title.classList.add("cursor-pointer");
        title.addEventListener("click", (e) => {
            e.preventDefault();

            if (content.style.display === "none") {
                content.style.display = "flex";
                icon.style.transform = "rotate(180deg)";
            } else {
                content.style.display = "none";
                icon.style.transform = "rotate(0deg)";
            }
        });

        content.style.display = "none";
        icon.style.transform = "rotate(0deg)";
    })();
}
